module.exports = "( {{$ctrl.ps.getQuantiteTotale()}} | {{$ctrl.ps.getPrixTotal()}} € )"


//////////////////
// WEBPACK FOOTER
// ./src/panierIndicateur.component/panierIndicateur.html
// module id = 95
// module chunks = 0